export const tr = {
  'ad.label': 'Reklam',
  'ad.sponsored_by': '{advertiser} sponsorluğunda',
  'ad.visit': 'Ziyaret et',
  'cookies.preferences': 'Çerez tercihleri',
  'cookies.title': 'Gizliliğiniz sizin kontrolünüzde',
  'cookies.description': 'Albambam\'ın çalışması için gerekli depolamayı kullanıyoruz. Analitik veya pazarlamayı yalnızca izninizle etkinleştiririz. İzninizi istediğiniz zaman geri çekebilirsiniz. Şunu okuyun:',
  'cookies.privacy_link': 'Gizlilik Politikası',
  'cookies.close': 'Tercihleri kapat',
  'cookies.necessary': 'Gerekli',
  'cookies.necessary_desc': 'Oturum, güvenlik, dil ve temel tercihler.',
  'cookies.analytics': 'Analitik',
  'cookies.analytics_desc': 'Hizmeti iyileştirmek için anonim kullanım ölçümü.',
  'cookies.marketing': 'Pazarlama',
  'cookies.marketing_desc': 'Reklam kişiselleştirme ve kampanya ölçümü.',
  'cookies.configure': 'Yapılandır',
  'cookies.reject': 'İsteğe bağlıları reddet',
  'cookies.save': 'Seçimi kaydet',
  'cookies.accept': 'Tümünü kabul et',
  'lang.selector_label': 'Dil',
  'lang.changed': 'Dil değiştirildi',
  'nav.home': 'Ana sayfa',
  'nav.categories': 'Kategoriler',
  'nav.shorts': 'Shorts',
  'nav.friends': 'Arkadaşlık',
  'nav.upload': 'Yükle',
  'nav.profile': 'Profil',
  'nav.login': 'Giriş yap',
  'common.signed_in': 'Giriş yapıldı',
  'common.error': 'Hata',
  'topbar.search_placeholder': 'Video, içerik üretici ara...',
  'legal.terms': 'Şartlar',
  'legal.privacy': 'Gizlilik',
  'nav.admin': 'Yönetim',
  'nav.logout': 'Çıkış yap',
  'admin.tab.payments': 'Ödemeler',
  'admin.payments.title': 'Ödemeler',
  'cats.title': 'Kategoriler',
  'cats.all': 'Tümü',
  'cats.adult_title': '18+ kategoriler',
  'cats.empty': 'Bu kategoride video yok.',
  'friends.block_confirm': 'Bu arkadaş engellensin mi? Artık sohbet edemeyecek ve birbirinizi arkadaş olarak göremeyeceksiniz.',
  'friends.accepted': 'Artık arkadaşsınız!',
  'friends.title': 'Arkadaşlık',
  'friends.subtitle': 'Yalnızca karşılıklı takip edenler arkadaş olur ve özel sohbet edebilir.',
  'friends.unread_count_label': '{n} okunmamış mesaj',
  'friends.blocked_users_title': 'Engellenen kullanıcılar',
  'friends.unblock_user': 'Engeli kaldır',
  'friends.requests_title': 'Sohbet istekleri',
  'friends.request_badge': 'İstek',
  'friends.request_accept': 'Kabul et',
  'friends.request_ignore': 'Yoksay',
  'friends.empty_title': 'Henüz arkadaş yok',
  'friends.empty_subtitle': 'Özel sohbeti açmak için birini takip et ve karşılığında takip edil.',
  'friends.attach_image': 'Fotoğraf',
  'friends.shared_video_label': 'Bir video paylaştı',
  'friends.select_conversation': 'Sohbete başlamak için bir arkadaş seç',
  'friends.block_user': 'Engelle',
  'friends.no_messages_yet': 'Henüz mesaj yok. Selam ver!',
  'friends.message_placeholder': 'Bir mesaj yaz...',
  'section.trending': 'Trendler',
  'section.shorts': 'Shorts',
  'section.for_you': 'Sana özel',
  'home.hero.badge': 'Albambam\'a hoş geldiniz',
  'home.hero.title_1': 'Kısa videolar.',
  'home.hero.title_2': 'Gerçek içerik üreticiler.',
  'home.hero.subtitle': 'İzle, paylaş ve kazan. Videolarını yükle ve her kategoride yeni yetenekleri keşfet.',
  'home.hero.cta_shorts': 'Shorts İzle',
  'home.hero.cta_trending': 'Trendler',
  'home.shorts.see_all': 'Tümünü gör',
  'home.empty.title': 'Henüz video yok',
  'home.empty.subtitle': 'İçerik üreticiler içerik yüklediğinde burada görünecek.',
  'live.send_diamonds': 'Elmas gönder',
  'live.buy': 'Satın al',
  'live.chat': 'Sohbet',
  'live.type_message': 'Bir mesaj yaz...',
  'live.send': 'Gönder',
  'auth.success_google': 'Google ile giriş yapıldı',
  'auth.fail_google': 'Geçersiz Google oturumu',
  'auth.success_login': 'Giriş yapıldı',
  'auth.success_register': 'Hesap oluşturuldu',
  'auth.login_tab': 'Giriş yap',
  'auth.register_tab': 'Hesap oluştur',
  'auth.email': 'E-posta',
  'auth.password': 'Şifre',
  'auth.submit_login_loading': 'Giriş yapılıyor...',
  'auth.submit_login': 'Giriş yap',
  'auth.name': 'Ad',
  'auth.submit_register_loading': 'Oluşturuluyor...',
  'auth.submit_register': 'Hesap oluştur',
  'auth.or': 'veya',
  'legal.privacy_title': 'Gizlilik Politikası',
  'search.title': '"{q}" için sonuçlar',
  'search.count': '{n} video',
  'search.empty': 'Sonuç yok.',
  'series.load_error': 'Dizi yüklenemedi',
  'series.unlocked': 'Dizi kilidi açıldı',
  'series.purchase_error': 'Satın alma başlatılamadı',
  'series.restricted': 'Erişim kısıtlı',
  'series.configure_access': 'Erişimi yapılandır',
  'series.language_all': 'Tüm diller',
  'series.episode_count': '{n} bölüm',
  'series.buy': 'Diziyi satın al',
  'series.filter_language': 'Dile göre filtrele',
  'series.no_episodes': 'Henüz yayınlanmış bölüm yok.',
  'series.episode_number': 'Bölüm {n}',
  'legal.terms_title': 'Şartlar ve Koşullar',
  'lang.ca': 'Katalanca',
  'lang.en': 'İngilizce',
  'lang.es': 'İspanyolca',
  'lang.fr': 'Fransızca',
  'lang.de': 'Almanca',
  'lang.it': 'İtalyanca',
  'lang.eu': 'Baskça',
  'lang.gl': 'Galiçyaca',
  'lang.zh': 'Çince',
  'lang.other': 'Diğer',
  'lang.vi': 'Vietnamca',
  'lang.ja': 'Japonca',
  'lang.ko': 'Korece',
  'lang.ru': 'Rusça',
  'lang.ro': 'Rumence',
  'lang.ar': 'Arapça',
  'lang.tr': 'Türkçe',
  'lang.pl': 'Lehçe',
  'lang.ms': 'Malayca',
  'lang.ta': 'Tamilce',
  'upload.series_title_error': 'Dizinin başlığını gir',
  'upload.series_adult_category_error': 'Dizi için bir 18+ kategorisi seç',
  'upload.series_created': 'Dizi oluşturuldu',
  'upload.series_create_error': 'Dizi oluşturulamadı',
  'upload.err_file': 'Geçerli bir video dosyası seç',
  'upload.err_title': 'Bir başlık belirle',
  'upload.series_select_error': 'Bir dizi seç veya oluştur',
  'upload.trailer_target_error': 'Fragmanın videosunu veya dizisini seç',
  'upload.price_error': 'En az 0,50 EUR tutarında geçerli bir fiyat gir.',
  'upload.adult_category_error': 'Bir yetişkin kategorisi seç',
  'upload.success': 'Video başarıyla yüklendi',
  'upload.title_h': 'Video yükle',
  'upload.kind': 'Yayın türü',
  'upload.kind_video': 'Bağımsız video',
  'upload.kind_episode': 'Dizi bölümü',
  'upload.kind_trailer': 'Shorts\'ta herkese açık fragman',
  'upload.series': 'Dizi',
  'upload.series_select': 'Bir dizi seç',
  'upload.episode': 'Bölüm',
  'upload.series_new_title': 'Yeni dizi başlığı',
  'upload.series_create': 'Dizi oluştur',
  'upload.series_adult': '18+ dizi',
  'upload.series_premium': 'Premium dizi',
  'upload.series_adult_category': 'Dizinin 18+ kategorisi',
  'upload.series_price': 'Bölüm ve paket fiyatı (EUR)',
  'upload.trailer_for': 'Fragman şunu tanıtıyor',
  'upload.trailer_select': 'Bir video veya dizi seç',
  'upload.video_prefix': 'Video',
  'upload.file_label': 'Video dosyası (MP4, en fazla 1GB)',
  'upload.file_pick': 'Bir video seçmek için tıkla',
  'upload.thumb_label': 'Küçük resim (isteğe bağlı)',
  'upload.video_title': 'Başlık',
  'upload.description': 'Açıklama',
  'upload.category': 'Kategori',
  'upload.is_short': 'Bir Short (dikey)',
  'upload.paid_video': 'Ücretli video',
  'upload.adult_content': '18+ içerik',
  'upload.video_language': 'Video dili',
  'upload.individual_price': 'Bu videoyu izleme fiyatı (EUR)',
  'upload.paid_video_help': 'İzleyici yalnızca bu videoya kalıcı erişim satın alır. Minimum fiyat 0,50 EUR\'dur.',
  'upload.adult_category': 'Yetişkin kategorisi',
  'upload.uploading': 'Yükleniyor %{n}',
  'upload.submit': 'Videoyu yükle',
  'user.followers': 'takipçi',
  'user.following': 'takip edilen',
  'user.follow': 'Takip et',
  'user.chat_open': 'Sohbet et',
  'user.request_sent': 'İstek gönderildi',
  'user.send_message': 'Mesaj gönder',
  'user.followers_title': 'Takipçiler',
  'user.following_title': 'Takip edilenler',
  'user.unfollow': 'Takibi bırak',
  'user.request_title': 'Sohbet isteği',
  'user.request_subtitle': 'Yalnızca bir mesaj gönderebilirsin. İsteği kabul ederse arkadaş olursunuz ve sohbet edebilirsiniz.',
  'user.request_placeholder': 'Mesajını yaz...',
  'user.request_send': 'İstek gönder',
  'shorts.login_for_like': 'Beğenmek için giriş yap',
  'watch.share_copied': 'Bağlantı kopyalandı',
  'watch.delete_confirm': 'Bu yorum silinsin mi?',
  'ad.skip_in': '{n} sn içinde atla',
  'ad.skip': 'Reklamı atla',
  'watch.share': 'Paylaş',
  'friends.share_video': 'Bir video paylaş',
  'friends.send': 'Gönder',
  'watch.comments': 'Yorumlar',
  'watch.write_comment': 'Bir yorum yaz...',
  'watch.publish': 'Yayınla',
  'watch.login_to_comment': 'Yorum yapmak için giriş yapmalısın.',
  'watch.login_btn': 'Yorum yapmak için giriş yap',
  'watch.no_comments': 'Henüz yorum yok.',
  'watch.related': 'İlgili',
  'nav.trending': 'Trendler',
  'friends.follow_option_only_follow': 'Takip et',
  'friends.follow_option_friends': 'Arkadaşlar',
  'watch.like': 'Beğen',
  'watch.views_short': '{n} izlenme',
  'shorts.empty.title': 'Henüz Shorts yok',
  'shorts.empty.subtitle': 'Bölümü başlatmak için kısa bir video yükle.',
  'shorts.share': 'Paylaş',
  'auth.continue_google': 'Google ile devam et',
  'upload.is_premium': 'Premium',
  'upload.price': 'Fiyat (€)',
  'upload.err_select': 'Bir video seç',
  'profile.upload_btn': 'Video yükle',
  'profile.tab_videos': 'Videolarım ({n})',
  'profile.tab_history': 'Geçmiş',
  'profile.tab_recos': 'Öneriler',
  'profile.no_videos': 'Henüz hiç video yüklemedin.',
  'profile.no_history': 'Henüz hiç video izlemedin.',
  'profile.no_recos': 'Öneriler almak için birkaç video izle.',
  'profile.likes': 'beğeni',
  'profile.views': 'izlenme',
  'wallet.title': 'Cüzdan',
  'wallet.rate_label': 'Oran',
  'wallet.min_label': 'Minimum para çekme',
  'wallet.amount_label': 'Çekilecek tutar',
  'wallet.withdraw_btn': 'Para çekme isteği',
  'wallet.history_title': 'İstek geçmişi',
  'wallet.success': 'İstek oluşturuldu',
  'wallet.bad_amount': 'Geçersiz tutar',
  'wallet.per_view': '{rate} {cur}/izlenme',
  'admin.title': 'Yönetim',
  'admin.stats.users': 'Kullanıcılar',
  'admin.stats.videos': 'Videolar',
  'admin.stats.shorts': 'Shorts',
  'admin.stats.views': 'İzlenmeler',
  'admin.tab.videos': 'Videolar',
  'admin.tab.ads': 'Reklamlar',
  'admin.tab.users': 'Kullanıcılar',
  'admin.tab.withdrawals': 'Para çekmeler',
  'admin.tab.config': 'Ayarlar',
  'admin.tab.translations': 'Çeviriler',
  'tbl.title': 'Başlık',
  'tbl.creator': 'Oluşturan',
  'tbl.category': 'Kategori',
  'tbl.type': 'Tür',
  'tbl.views': 'İzlenme',
  'tbl.likes': 'Beğeni',
  'tbl.status': 'Durum',
  'tbl.actions': 'İşlemler',
  'tbl.placement': 'Konum',
  'tbl.advertiser': 'Reklam veren',
  'tbl.impressions': 'Gösterim',
  'tbl.clicks': 'Tıklama',
  'tbl.active': 'Aktif',
  'tbl.name': 'Ad',
  'tbl.email': 'E-posta',
  'tbl.role': 'Rol',
  'tbl.wallet': 'Cüzdan',
  'tbl.amount': 'Tutar',
  'tbl.date': 'Tarih',
  'tbl.user': 'Kullanıcı',
  'video.video': 'Video',
  'video.short': 'Short',
  'action.show': 'Yayınla',
  'action.hide': 'Gizle',
  'action.delete_confirm_video': 'Video silinsin mi?',
  'ad.create_h': 'Reklam oluştur',
  'ad.title_label': 'Başlık',
  'ad.image_label': 'Görsel URL\'si',
  'ad.target_label': 'Hedef URL',
  'ad.advertiser_label': 'Reklam veren',
  'ad.placement_label': 'Yerleşim',
  'ad.placement.banner': 'Banner (site)',
  'ad.placement.preroll': 'Pre-roll (videodan önce)',
  'ad.placement.overlay': 'Overlay (video içinde)',
  'ad.active': 'Aktif',
  'ad.create_btn': 'Oluştur',
  'ad.success_create': 'Reklam oluşturuldu',
  'ad.delete_confirm': 'Reklam silinsin mi?',
  'users.make_admin': 'Yönetici yap',
  'users.remove_admin': 'Yöneticiliği kaldır',
  'wd.approve': 'Onayla',
  'wd.reject': 'Reddet',
  'wd.mark_paid': 'Ödendi olarak işaretle',
  'wd.empty': 'İstek yok',
  'cfg.title': 'Ödeme ayarları',
  'cfg.rate_label': 'İzlenme başına ödeme ({cur})',
  'cfg.min_label': 'Minimum para çekme ({cur})',
  'cfg.currency': 'Para birimi',
  'cfg.save': 'Kaydet',
  'cfg.saved': 'Ayarlar kaydedildi',
  'trans.title': 'Diller ve çeviriler',
  'trans.intro': 'Herhangi bir dil kodu (ör. ja, pt, zh) için çeviriler içeren bir JSON dosyası yükle. Dosya, anahtar → metin şeklinde düz bir eşleme içermelidir.',
  'trans.code_label': 'Dil kodu (ör. ja, pt-BR, zh)',
  'trans.name_label': 'Ad (o dilde)',
  'trans.file_label': 'Çeviri JSON dosyası',
  'trans.upload': 'Yükle',
  'trans.uploaded': 'Çeviriler kaydedildi',
  'trans.delete': 'Sil',
  'trans.delete_confirm': 'Bu dil silinsin mi?',
  'trans.builtin': 'Yerleşik',
  'trans.custom': 'Özel',
  'trans.empty_custom': 'Henüz özel dil yok.',
  'common.cancel': 'İptal',
  'common.loading': 'Yükleniyor...',
  'common.too_fast': 'Çok hızlı, lütfen biraz bekle',
  'time.few_seconds': 'birkaç saniye önce',
  'time.min': '{n} dk önce',
  'time.h': '{n} sa önce',
  'time.d': '{n} gün önce',
  'time.w': '{n} hf önce',
  'time.mo': '{n} ay önce',
  'time.y': '{n} yıl önce',
  'brand.tagline': 'Kısa videolar. Gerçek içerik üreticiler.',
  'live.section': 'Canlı',
  'live.start': 'Canlı yayını başlat',
  'live.end': 'Canlı yayını bitir',
  'live.join': 'Canlı yayına katıl',
  'live.chat_placeholder': 'Bir mesaj yaz...',
  'live.diamond': 'Elmas',
  'live.buy_access': 'Erişim satın al',
  'live.save_recording': 'Kaydı kaydet',
};
